// Registers public/sw.js. Safe to call from every page: registration is
// idempotent (the browser no-ops if the same script/scope is already
// registered) and scoped to "/", so whichever page a user lands on first
// installs the worker and it then controls the whole origin.
//
// sw.js never intercepts /api/* or /w/* (recording upload, live watch poll),
// so calling this can't turn a real network failure into a fake success --
// it only ever affects static-asset caching and the app-shell offline
// fallback. See public/sw.js for the actual caching strategy.
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed', err);
    });
  });
}
